import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_SALARY_TYPES } from './get-salary-types.hook';
import { GET_SALARY_TYPES_BY_IDS } from './get-salary-types-by-ids.hook';
import { GET_SALARY_TYPE_BY_ID } from './get-salary-types-by-id.hook';
import { GET_ALL_SALARY_TYPES } from './get-all-salary-types.hook';


export const UPDATE_SALARY_TYPE = gql`
  mutation updateSalaryTypes($payload: UpdateSalaryTypesInput!) {
    updateSalaryTypes(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateSalaryTypes = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [updateSalaryTypes, { loading }] = useMutation(UPDATE_SALARY_TYPE, {
    onCompleted: data => {
      if (data?.updateSalaryTypes?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('salaryTypes.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [
      GET_SALARY_TYPES,
      GET_SALARY_TYPES_BY_IDS,
      GET_SALARY_TYPE_BY_ID,
      GET_ALL_SALARY_TYPES,
  ]});

  return { updateSalaryTypes, loading };
};
